import { render, staticRenderFns } from "./FormBoldItalic.vue?vue&type=template&id=830cb8da&scoped=true&"
import script from "./FormBoldItalic.vue?vue&type=script&lang=js&"
export * from "./FormBoldItalic.vue?vue&type=script&lang=js&"
import style0 from "./FormBoldItalic.vue?vue&type=style&index=0&id=830cb8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830cb8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
